import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { CreationDetailFragment } from '../../../generated/graphql';
import CreativeFormatCreativeTypeIcon from '../../component/compound/CreativeFormatCreativeTypeIcon';
import CreativeFormatNetworkIcon from '../../component/compound/CreativeFormatNetworkIcon';
import DummyContent from '../../component/primitive/DummyContent';
import { SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';
import { gridLayoutItem } from '../../styleUtility/gridLayout';

type Props = {
  creation: CreationDetailFragment | null;
  className?: string;
};

const CreationCreativeFormat: FC<Props> = ({ className, creation }) => {
  if (creation) {
    const { network, placement, attribute, creativeType } = creation.creativeFormat;
    const networkAndPlacementMessage = `${network.name} ${placement.name}`;
    const playbackTimeMessage = attribute.playbackTime ? (
      <FormattedMessage id="creative_format.playback_time" values={{ seconds: attribute.playbackTime.seconds }} />
    ) : (
      ''
    );
    const aspectRatioMessage = attribute.aspectRatio ? (
      attribute.aspectRatio.aspectRatio.width === 0 &&
      attribute.aspectRatio.aspectRatio.height === 0 &&
      attribute.aspectRatio.size.width === 0 &&
      attribute.aspectRatio.size.height === 0 ? (
        <FormattedMessage id="creative_format.aspect_ratio.nullable" />
      ) : (
        `${attribute.aspectRatio.aspectRatio.width}:${attribute.aspectRatio.aspectRatio.height} (${attribute.aspectRatio.size.width}x${attribute.aspectRatio.size.height})`
      )
    ) : (
      <FormattedMessage id="creative_format.aspect_ratio.nullable" />
    );
    const iconStyle = {
      height: 24,
      width: 24,
      marginRight: SPACING_UNIT,
    };
    const CreativeTypeIcon = styled(CreativeFormatCreativeTypeIcon)(iconStyle, gridLayoutItem('type'));
    const NetworkIcon = styled(CreativeFormatNetworkIcon)(iconStyle, gridLayoutItem('network'));
    return (
      <Wrapper className={className} variant="subtitle1" color="textSecondary">
        <CreativeTypeIcon creativeType={creativeType} />
        <NetworkIcon network={network} />
        <PlacementLabel>
          {networkAndPlacementMessage} <br />
          {aspectRatioMessage} <br />
          {playbackTimeMessage}
        </PlacementLabel>
      </Wrapper>
    );
  } else {
    return <DummyContent />;
  }
};

const Wrapper = styled(Typography)(
  flexibleLayoutContainer({
    alignItems: 'center',
    justifyContent: 'flex-start',
  }),
);

const PlacementLabel = styled('div')({
  lineBreak: 'anywhere',
});

export default CreationCreativeFormat;
